module.exports = __webpack_public_path__ + "img/Compass-Logo-fond-fonce-B.fa6462d4.png";